import * as _ from 'lodash';
import type { QueryKey } from '@tanstack/react-query';
import { post } from '../../../../redux/api';
import { queryClient, useMutation } from '../../../../ReactQuery';
import type { GitHubAppInstallation } from '../../../../../shared/model-typings';
import type { QueryResponse } from '../../../../ReactQuery/useQuery';

export type GitHubAppInstallationRequest = {
  gitHubInstallationId: string,
};

const queryKey: QueryKey = ['github-app', 'installations'];

async function createGitHubAppInstallation(
  request: GitHubAppInstallationRequest,
): Promise<QueryResponse<GitHubAppInstallation>> {
  try {
    return await post<GitHubAppInstallationRequest, GitHubAppInstallation>('/api/services/github-app/installations', request);
  } catch (e) {
    // redux API can throw an error or throw a Response object
    const message = _.get(e, 'data.message') || _.get(e, 'body');
    if (message) {
      throw new Error(message);
    }

    throw e;
  }
}

/**
 * Hook used to create a new GitHub app installation.
 */
export default function useCreateGitHubAppInstallation() {
  return useMutation<GitHubAppInstallationRequest, QueryResponse<GitHubAppInstallation>, Error>({
    mutationFn: createGitHubAppInstallation,
    onSuccess: () => {
      queryClient.invalidateQueries(queryKey);
    },
  });
}
